// client/src/components/StandbyBookingModal.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Form, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { scheduleBooking } from '../services/api';

const StandbyBookingModal = ({ show, onHide, course, targetDate }) => {
    const [startTime, setStartTime] = useState('08:00');
    const [endTime, setEndTime] = useState('11:00');
    const [capacity, setCapacity] = useState(4);
    const [expireHours, setExpireHours] = useState(4);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        const standbyData = {
            courseId: course.id,
            targetDate,
            startTime,
            endTime,
            capacity: parseInt(capacity),
            // ✅ 2. Add expireHours to the data sent to the server
            expireHours: parseInt(expireHours),
            initialStatus: 'standby_active',
        };

        try {
            const result = await scheduleBooking(standbyData);
            if (result.success) {
                alert('You have successfully joined the standby list! Check "My Bookings" for status updates.');
                onHide();
                navigate('/bookings');
            } else {
                setError(result.error || 'An unknown error occurred.');
            }
        } catch (err) {
            setError(err.error || 'Failed to submit request.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Join Standby List for {course?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted">
                    No times are available that match your filters. Join the standby list, and we'll notify you and attempt to book a time if one opens up in your desired window.
                </p>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Target Date</Form.Label>
                                <Form.Control type="date" value={targetDate} readOnly disabled />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Number of Players</Form.Label>
                                <Form.Select value={capacity} onChange={e => setCapacity(e.target.value)}>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Earliest Time</Form.Label>
                                <Form.Control type="time" value={startTime} onChange={e => setStartTime(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Latest Time</Form.Label>
                                <Form.Control type="time" value={endTime} onChange={e => setEndTime(e.target.value)} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3">
                        <Form.Label>Stop Trying Before Tee Time</Form.Label>
                        <Form.Select value={expireHours} onChange={e => setExpireHours(e.target.value)}>
                            <option value="1">1 hour</option>
                            <option value="2">2 hours</option>
                            <option value="4">4 hours (default)</option>
                            <option value="8">8 hours</option>
                        </Form.Select>
                    </Form.Group>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide} disabled={isLoading} className="me-2">
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={isLoading}>
                            {isLoading ? <Spinner as="span" animation="border" size="sm" /> : 'Join Standby List'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default StandbyBookingModal;